class QuoteDrawer {
  constructor() {
    this.root = document.querySelector('[js-ird-quote-drawer]');

    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onRootClick = this.onRootClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);

    this.attachEvents();
    this.openAfterSubmit();
  }

  get form() {
    return this.root?.querySelector('[js-quote-drawer-form]') || null;
  }

  openAfterSubmit() {
    const feedback = this.root?.querySelector('.ird-contact__status');
    if (!feedback) return;

    // Page contact form also uses Shopify's contact form — don't open the drawer there.
    const pageContactFeedback = document.querySelector(
      '.ird-section.ird-contact .ird-contact__status'
    );
    if (pageContactFeedback) return;

    this.open();
  }

  attachEvents() {
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeydown);
    if (this.root) {
      this.root.addEventListener('click', this.onRootClick);
      this.root.addEventListener('submit', this.onFormSubmit);
    }
  }

  onDocumentClick(event) {
    const openTrigger = event.target.closest('[js-quote-drawer-open]');
    if (!openTrigger) return;

    event.preventDefault();
    this.open(openTrigger);
  }

  onRootClick(event) {
    const closeTrigger = event.target.closest('[js-quote-drawer-close]');
    if (!closeTrigger) return;

    event.preventDefault();
    this.close();
  }

  onKeydown(event) {
    if (event.key === 'Escape' && document.body.classList.contains('-quote-drawer-open')) {
      this.close();
    }
  }

  onFormSubmit(event) {
    const form = event.target.closest('[js-quote-drawer-form]');
    if (!form) return;

    const submitButton = form.querySelector('[js-contact-submit]');
    const submitLabel = form.querySelector('[js-contact-submit-label]');
    if (submitButton instanceof HTMLButtonElement) {
      submitButton.disabled = true;
    }
    if (submitLabel && form.dataset.sending) {
      submitLabel.textContent = form.dataset.sending;
    }
  }

  async resolveProducts(trigger) {
    const fromTrigger = trigger?.getAttribute('data-quote-products')?.trim();
    if (fromTrigger) return fromTrigger;

    const productSection = document.querySelector('.ird-product');
    if (productSection) {
      const title = productSection.querySelector('.ird-product__title')?.textContent?.trim();
      const variant = document.querySelector('[js-product-sticky-variant]')?.textContent?.trim();
      if (title) {
        const line = variant ? `${title} / ${variant}` : title;
        return `${line}\n${window.location.href}`;
      }
    }

    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!response.ok) return '';

      const cart = await response.json();
      return (cart.items || [])
        .map((item) => {
          const variant =
            item.variant_title && item.variant_title !== 'Default Title'
              ? ` / ${item.variant_title}`
              : '';
          const sku = item.sku ? ` (SKU: ${item.sku})` : '';
          return `- ${item.product_title}${variant} × ${item.quantity}${sku}`;
        })
        .join('\n');
    } catch (error) {
      console.error('[IRD QuoteDrawer] unable to resolve products:', error);
      return '';
    }
  }

  setProductsValue(value) {
    const form = this.form;
    const productsField = form?.querySelector('[js-quote-products]');
    if (!(productsField instanceof HTMLInputElement || productsField instanceof HTMLTextAreaElement)) {
      return;
    }

    productsField.value = value || '';
  }

  async open(trigger) {
    document.body.classList.remove(
      '-minicart-open',
      '-menu-open',
      '-desktop-menu-open',
      '-search-open'
    );
    document.querySelectorAll('[js-cart-toggle]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('[js-header-menu-toggle]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('[js-search-toggle]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });

    document.body.classList.add('-quote-drawer-open');
    this.toggleLenis(false);

    if (trigger) {
      const products = await this.resolveProducts(trigger);
      this.setProductsValue(products);
    }

    const firstInput = this.form?.querySelector('input:not([type="hidden"]), textarea');
    if (firstInput instanceof HTMLElement) {
      requestAnimationFrame(() => firstInput.focus());
    }
  }

  close() {
    document.body.classList.remove('-quote-drawer-open');
    this.toggleLenis(true);
  }

  toggleLenis(shouldStart) {
    if (!window.lenis) return;
    if (shouldStart) {
      window.lenis.start();
    } else {
      window.lenis.stop();
    }
  }
}

export default QuoteDrawer;
